import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import DiscussionForm from '../Form';
import { createDiscussion } from '@resources/Discussion/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createDiscussion, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createDiscussion(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.discussion.create',
						defaultMessage:
							'A new Discussion has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.discussion',
					defaultMessage: 'Create Discussion',
				})}
			</Title>
			<Section className="mb-5">
				<DiscussionForm
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	discussions,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		discussions,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createDiscussion,
})(Create);
